const prefix = '/api/v1';

module.exports = {
    httpApiPrefixPath: prefix,
    socketApiPrefixPath: `${prefix}/socket.io`,
};



// WEBPACK FOOTER //
// ./src/sources/ApiPaths.js